// Calendar.js

// import React...
import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { updateSchedule } from '../actions/calendar-actions';
 
// ... and fullcalendar-reactwrapper.
import FullCalendar from 'fullcalendar-reactwrapper';


class Calendar extends Component {
    constructor(props) {
        super(props);
        this.state = {
        eventSources:[
/*            {
                url: 'http://beisekerice.com/rest/calendar.php',
                type: 'GET'

                //default anonymous will have read-only access (no Authorization header)
            },*/
            {
//                url: '/api/v0/calendar',
                url: 'https://beisekerice.com/api/v0/calendar?showHidden=true',
//                  url: 'http://localhost:3001/api/v0/calendar',
                type: 'GET'
            }

        ],
        tiering : [
        /*{ title : 'Beiseker - AT3 vs TBD', start : '2018-11-17T10:45:00', end : '2018-11-17T12:30:00', type: 'Game' },
        { title : 'Beiseker - AT3 vs TBD', start : '2018-11-18T11:30:00', end : '2018-11-18T13:15:00', type: 'Game' },
        { title : 'Beiseker - AT3 vs TBD', start : '2018-11-25T09:30:00', end : '2018-11-25T11:15:00', type: 'Game' },
        { title : 'Beiseker - AT3 vs TBD', start : '2018-12-01T10:45:00', end : '2018-12-01T12:30:00', type: 'Game' },
        { title : 'Beiseker - AT3 vs TBD', start : '2019-01-06T09:30:00', end : '2019-01-06T11:15:00', type: 'Game' },
        { title : 'Beiseker - AT3 vs TBD', start : '2019-01-12T10:45:00', end : '2019-01-12T12:30:00', type: 'Game' },
        { title : 'Beiseker - AT3 vs TBD', start : '2019-01-13T11:30:00', end : '2019-01-13T13:15:00', type: 'Game' },
        { title : 'Beiseker - AT3 vs TBD', start : '2019-01-20T09:30:00', end : '2019-01-20T11:15:00', type: 'Game' },
        { title : 'Beiseker - AT3 vs TBD', start : '2019-02-17T09:30:00', end : '2019-02-17T11:15:00', type: 'Game' },
        { title : 'Beiseker - AT5 vs TBD', start : '2018-11-18T09:30:00', end : '2018-11-18T11:15:00', type: 'Game' },
        { title : 'Beiseker - AT5 vs TBD', start : '2018-11-24T10:45:00', end : '2018-11-24T12:30:00', type: 'Game' },
        { title : 'Beiseker - AT5 vs TBD', start : '2018-12-02T09:30:00', end : '2018-12-02T11:15:00', type: 'Game' },
        { title : 'Beiseker - AT5 vs TBD', start : '2019-01-05T10:45:00', end : '2019-01-05T12:30:00', type: 'Game' },
        { title : 'Beiseker - AT5 vs TBD', start : '2019-01-06T11:30:00', end : '2019-01-06T13:15:00', type: 'Game' },
        { title : 'Beiseker - AT5 vs TBD', start : '2019-01-13T09:30:00', end : '2019-01-13T11:15:00', type: 'Game' },
        { title : 'Beiseker - AT5 vs TBD', start : '2019-02-10T09:30:00', end : '2019-02-10T11:15:00', type: 'Game' },
        { title : 'Beiseker - AT5 vs TBD', start : '2019-02-16T10:45:00', end : '2019-02-16T12:30:00', type: 'Game' },
        { title : 'Beiseker - AT5 vs TBD', start : '2019-02-17T11:30:00', end : '2019-02-17T13:15:00', type: 'Game' },
        { title : 'Beiseker - BT4 vs TBD', start : '2018-11-17T15:00:00', end : '2018-11-17T17:00:00', type: 'Game' },
        { title : 'Beiseker - BT4 vs TBD', start : '2019-02-10T14:45:00', end : '2019-02-10T16:45:00', type: 'Game' },
        { title : 'Beiseker - BT4 vs TBD', start : '2018-11-24T18:15:00', end : '2018-11-24T20:15:00', type: 'Game' },
        { title : 'Beiseker - BT4 vs TBD', start : '2019-01-05T15:15:00', end : '2019-01-05T17:15:00', type: 'Game' },
        { title : 'Beiseker - BT4 vs TBD', start : '2019-01-06T16:45:00', end : '2019-01-06T18:45:00', type: 'Game' },
        { title : 'Beiseker - BT4 vs TBD', start : '2019-01-12T15:45:00', end : '2019-01-12T17:45:00', type: 'Game' },
        { title : 'Beiseker - BT4 vs TBD', start : '2019-01-13T14:30:00', end : '2019-01-13T16:30:00', type: 'Game' },
        { title : 'Beiseker - BT4 vs TBD', start : '2019-01-19T17:30:00', end : '2019-01-19T19:30:00', type: 'Game' },
        { title : 'Beiseker - BT4 vs TBD', start : '2019-02-15T18:00:00', end : '2019-02-15T20:00:00', type: 'Game' },
        { title : 'Beiseker - BT4 vs TBD', start : '2019-02-16T15:15:00', end : '2019-02-16T17:15:00', type: 'Game' },
        { title : 'Beiseker - BT4 vs TBD', start : '2019-02-17T16:45:00', end : '2019-02-17T18:45:00', type: 'Game' },
        { title : 'Beiseker - MT4 vs TBD', start : '2018-11-16T19:00:00', end : '2018-11-16T21:15:00', type: 'Game' },
        { title : 'Beiseker - MT4 vs TBD', start : '2018-11-17T17:15:00', end : '2018-11-17T19:30:00', type: 'Game' },
        { title : 'Beiseker - MT4 vs TBD', start : '2018-11-23T19:00:00', end : '2018-11-23T21:15:00', type: 'Game' },
        { title : 'Beiseker - MT4 vs TBD', start : '2018-11-30T19:00:00', end : '2018-11-30T21:15:00', type: 'Game' },
        { title : 'Beiseker - MT4 vs TBD', start : '2019-01-04T19:00:00', end : '2019-01-04T21:15:00', type: 'Game' },
        { title : 'Beiseker - MT4 vs TBD', start : '2019-01-05T17:30:00', end : '2019-01-05T19:45:00', type: 'Game' },
        { title : 'Beiseker - MT4 vs TBD', start : '2019-01-11T18:00:00', end : '2019-01-11T20:15:00', type: 'Game' },
        { title : 'Beiseker - MT4 vs TBD', start : '2019-01-12T18:00:00', end : '2019-01-12T20:15:00', type: 'Game' },
        { title : 'Beiseker - MT4 vs TBD', start : '2019-02-08T19:00:00', end : '2019-02-08T21:15:00', type: 'Game' },
        { title : 'Beiseker - MT4 vs TBD', start : '2019-02-10T17:00:00', end : '2019-02-10T19:15:00', type: 'Game' },
        { title : 'Beiseker - MT4 vs TBD', start : '2019-02-16T17:30:00', end : '2019-02-16T19:45:00', type: 'Game' },
        { title : 'Beiseker - PT4 vs TBD', start : '2018-11-17T12:45:00', end : '2018-11-17T14:45:00', type: 'Game' },
        { title : 'Beiseker - PT4 vs TBD', start : '2018-11-18T14:30:00', end : '2018-11-18T16:30:00', type: 'Game' },
        { title : 'Beiseker - PT4 vs TBD', start : '2018-11-24T12:45:00', end : '2018-11-24T14:45:00', type: 'Game' },
        { title : 'Beiseker - PT4 vs TBD', start : '2018-11-25T14:15:00', end : '2018-11-25T16:15:00', type: 'Game' },
        { title : 'Beiseker - PT4 vs TBD', start : '2018-12-01T12:45:00', end : '2018-12-01T14:45:00', type: 'Game' },
        { title : 'Beiseker - PT4 vs TBD', start : '2019-01-06T14:30:00', end : '2019-01-06T16:30:00', type: 'Game' },
        { title : 'Beiseker - PT4 vs TBD', start : '2019-01-19T13:30:00', end : '2019-01-19T15:30:00', type: 'Game' },
        { title : 'Beiseker - PT4 vs TBD', start : '2019-01-20T16:45:00', end : '2019-01-20T18:45:00', type: 'Game' },
        { title : 'Beiseker - PT4 vs TBD', start : '2019-02-17T14:30:00', end : '2019-02-17T16:30:00', type: 'Game' },
         */
        ]
      }
    };

    handleEventClick(event) {
        //this.props.onUpdateCalendar(event.start.format(), 'agendaWeek');
        this.props.history.push('/admin/event/' + event.guid);
        console.log('handleEventClick', event);
        //alert('Event: ') + event;
        //alert('Coordinates: ');
        //alert('View: ');
    }

    handleEventAfterAllRender(view) {
        var lastDate = view.start.format();
        var lastView = view.type.trim();
        this.state.loading = false;
        //console.log('handleEventAfterAllRender existing:', this.props.calendar.lastDate, this.props.calendar.lastView);
        //console.log('handleEventAfterAllRender', lastDate, lastView);
        if (this.props.calendar.lastDate !== lastDate || this.props.calendar.lastView !== lastView) {
            console.log('handleEventAfterAllRender updating calendar settings');
            this.props.onUpdateCalendar(lastDate, lastView);
        }        
    }

    handleLoading(isLoading, view) {
        this.toggleOverlay();
        console.log('handleLoading', isLoading);
        //alert("handleLoading: " + isLoading);
        //this.state.loading = isLoading;
        //this.state.loading = false;
    }

    handleDropEvent(event) {
        console.log('moving event ' + event.guid + " start:" + event.start + " end:" + event.end);
        var start = new moment(event.start).format('YYYY-MM-DDTHH:mm:ss');
        var end = new moment(event.end).format('YYYY-MM-DDTHH:mm:ss');
        var movePatch = { start: start, end: end, type: event.type, title: event.title};
        console.log(JSON.stringify(movePatch));
//        var moveUrl = "http://localhost:3001/api/v0/events/" + event.guid;
        var moveUrl = "https://beisekerice.com/api/v0/events/" + event.guid;
        console.log(moveUrl);
        var response = fetch(moveUrl, {
            method: 'PUT',
            headers: {
               'Accept': 'application/json',
               'Content-Type': 'application/json',
               'Authorization': 'Token ' + this.props.user.token
            },
            body: JSON.stringify(movePatch)
            }).then(
                console.log(response),
            );
    }

    handleSelection(start, end) {
        //alert('Online Ice rental for 2018-2019 coming soon.');
        //alert('Coordinates: ');
        //alert('View: ');
        this.props.history.push('/newEvent/' + start.format('YYYYMMDDHHmm') + '/' + end.format('YYYYMMDDHHmm'));
    }

//( event, delta, revertFunc, jsEvent, ui, view )
    handleEventResize(event) { 
        console.log('resizing event ' + event.guid + " start:" + event.start + " end:" + event.end);
        var start = new moment(event.start).format('YYYY-MM-DDTHH:mm:ss');
        var end = new moment(event.end).format('YYYY-MM-DDTHH:mm:ss');
        var movePatch = { start: start, end: end, type: event.type, title: event.title};
        console.log(JSON.stringify(movePatch));
//        var moveUrl = "http://localhost:3001/api/v0/events/" + event.guid;
        var moveUrl = "https://beisekerice.com/api/v0/events/" + event.guid;
        console.log(moveUrl);
        var response = fetch(moveUrl, {
            method: 'PUT',
            headers: {
               'Accept': 'application/json',
               'Content-Type': 'application/json',
               'Authorization': 'Token ' + this.props.user.token
            },
            body: JSON.stringify(movePatch)
            }).then(
                console.log(response),
            );
    }
/*
    onUpdateCalendar(lastDate, lastView){
        console.log('onUpdateCalendar existing:', this.props.calendar.lastDate, this.props.calendar.lastView);
        console.log('onUpdateCalendar', lastDate, lastView);

        this.props.onUpdateCalendar(lastDate, lastView);
      }
*/

    toggleOverlay = () => {
        this.state.loading = !this.state.loading;
    };

      render() {
        return (
          <div id="example-component">
          <FullCalendar 
                 id = "calendar"
             header = {{
                left: 'prev,next,today',
                center: 'title',
                right: 'month,agendaWeek,agendaDay,listWeek'
            }}
            footer = {{
                left: 'prev,next,today',
                center: 'title',
                right: 'month,agendaWeek,agendaDay,listWeek'
            }}
            defaultDate = {this.props.calendar.lastDate || null}
            defaultView = {this.props.calendar.lastView || 'agendaWeek'}
            navLinks= {true} // can click day/week names to navigate views

            eventLimit= {true} // allow "more" link when too many events

            firstDay = {1}
            allDaySlot = {false}
            minTime = '08:00'
            slotLabelInterval = '01:00'
//            defaultView = 'agendaWeek'
            snapDuration = '00:15'
            editable= {false}
            editable = {true}
            selectable = {true}
			selectHelper = {true}
            selectOverlap = {false}
            contentHeight = 'auto'
			/*allDaySlot: false,
			minTime: "08:00",
			slotLabelInterval: "01:00",
			snapDuration: "00:15",
			contentHeight: "auto",
			defaultView: 'agendaWeek',
			eventBorderColor: '#5e5220',
			eventColor: '#af972b',
			editable: false,
			eventOverlap: falAse,
			droppable: true,
			selectable: true,
			selectHelper: true,
			selectOverlap: false,*/
            //events = {this.state.events}	
            eventSources = {this.state.eventSources}
            visibleRange = {this.state.visibleRange}
            eventDrop = {this.handleDropEvent.bind(this)}
            select = {this.handleSelection.bind(this)}
            eventClick = {this.handleEventClick.bind(this)}
            eventResize = {this.handleEventResize.bind(this)}
            eventAfterAllRender = {this.handleEventAfterAllRender.bind(this)}
            loading = {this.handleLoading.bind(this)}
            showNonCurrentDates = {false}
            


            //events = {this.state.tiering}

        />
          </div>
        );
      }
}

const mapStateToProps = state => ({
    cart: state.cart,
    user: state.user,
    alert: state.alert,
    calendar: state.calendar
  });
  
  const mapActionsToProps = {
    onUpdateCalendar: updateSchedule
  };
  
  
  export default connect(mapStateToProps, 
    mapActionsToProps
    )(Calendar);

//export default Calendar;


// WEBPACK FOOTER //
// ./src/components/Admin.js